 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		65: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		65: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~orange-lens~paint-~0019270f","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gallery-overlay~medi~bd43bb1c","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","5":"add-to-list-drawer~bath-renovation~orange-lens","6":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"add-to-list-drawer~magic-apron","10":"buybox~promotion-products-lazy","11":"buybox~super-sku","12":"compare~overlay","13":"promotion-products-lazy~quick-view","14":"ratings-and-reviews-mobile","15":"StoreLayout","16":"add-to-list-drawer","17":"aisle-bay","18":"augmented-reality","19":"bath-renovation","20":"breadcrumbs","21":"browse-and-search","22":"browse-and-search-mobile","23":"buybox","24":"calculator-pipcalculator","25":"collections","26":"collections-mobile","27":"common","28":"compare","29":"consumer-card-messaging","30":"customer-image-overlay","31":"drawer","32":"emt-generated-content","33":"emt-links","34":"emt-questions-and-answers-component","35":"fbr","36":"global-custom-configurator","37":"hammerjs","39":"home","40":"magic-apron","41":"measurement-guide","42":"measurement-guide-overlay-content","43":"media-gallery-filmstrip-mobile","44":"media-gallery-overlay","45":"media-gallery-overlay-mobile","46":"orange-lens","47":"order-sample","48":"order-sample-drawer","49":"overlay","50":"paint-reorder","51":"paint-reorder-mobile","52":"pep","53":"pep-mobile","54":"product","55":"product-mobile","56":"product-overview","57":"promotion-products-lazy","58":"question","59":"questions-and-answers","60":"quick-view","61":"ratings-and-reviews","62":"ratings-and-reviews-desktop","63":"results","64":"returns-messaging","66":"share-to-email-overlay","67":"share-to-pinterest-overlay","68":"size-guide-overlay","69":"specifications","70":"stylequiz","71":"super-sku","72":"vendor-collection-products","73":"vendor-collections","74":"vendor-collections-mobile","76":"video-player","77":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"92333c3cc21c21e66dd8","1":"66ba34bc9e48a853bfbb","2":"f73b1063273a2ae2372d","3":"d822f31290e0fafd14a4","4":"3cbcb82221f0662c621c","5":"5f228b5a0fff8c681432","6":"3beef14a59c7e8a4cbba","7":"f825ff689ccf4fc38987","8":"ab5a396ab9f389b745ec","9":"e925c74da44088b3406e","10":"e6f9b28317feb91e246d","11":"140bc4acb6239f23aac0","12":"8bfbfab0a3ede7d41354","13":"4c56f10ca650e0dc2ed3","14":"e94605daaa93ebe40580","15":"822a2a634a6de4437021","16":"d7197431426f3124b0a4","17":"6740c063f4be5b087508","18":"3a7f3a5668f44f3bbbfd","19":"3fee77332b9d3bc6bb6b","20":"bc0c6fb5a047b654601e","21":"dfa5b891b6c4f9425780","22":"0359d675482fc6adbd7a","23":"4e471f26d9860e07ed53","24":"668ce7425a37f9c8029b","25":"14ce60ef9c5c760b1065","26":"353dd51bc3fc978a59cb","27":"c807f392e60783d6a8e8","28":"75aa82ffd9a01a531e30","29":"71422ea56825cea28abb","30":"11691d4cbdba69d1c59f","31":"af64e79a74ac56930311","32":"987cc6fcee4a7edf0088","33":"7815348977274bda0cfa","34":"12c2a40911bf5ed6e941","35":"c642930a5dbde95148ae","36":"7f517e4eda780541c4d3","37":"a8df4125bdc5402050c7","39":"9d814a8564c470f31410","40":"e493a18f66583f7495e9","41":"bfa776919978b8b83480","42":"b797f99137d3b5ba3850","43":"e3b3dd1897471505050c","44":"740fecc04d9466398265","45":"12d1896e170567e8de6b","46":"c2320e6b56499a450b25","47":"c778d25339a47bb60fb5","48":"09191c63cec8f51c2e39","49":"6dc136074c40a3b7f2f8","50":"323c9377cf8234b3b14a","51":"efbb3c195d2e9b89fe96","52":"a8a8f737ac477f224e45","53":"f4e33aaaffd788b31950","54":"4af253ae2cae8ad70443","55":"37b2418b8b789b26c3d4","56":"62864e15d8e4ba5d794f","57":"c9cd3fd501ac9d934a65","58":"ea76bc285b95b77173eb","59":"fcbee7ffd65f88b4c7f9","60":"d97ff31a191ca68917aa","61":"7dad046ed86b8c271c10","62":"a27d6e40d4b1b5db6701","63":"4066d7ec191bc79f3675","64":"e896faf7cc3a72dba28c","66":"9ab21b5fc76d462f0432","67":"ee73c9dd5d197bffc344","68":"82648c883fd277154ed0","69":"e04f2457711d2a106f3b","70":"2858954c77db5ec8df3e","71":"c5209d4ecac3857e2ea0","72":"b119457494144986911f","73":"f524c97fff1da8a4c500","74":"55d4f6cb1154df4ca5e1","76":"8e97ab04810511db9834","77":"36c9726b255068a8636c","78":"5dcce69fa0fcb30dcdd7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"3":1,"4":1,"6":1,"7":1,"8":1,"11":1,"12":1,"13":1,"14":1,"17":1,"21":1,"22":1,"23":1,"25":1,"26":1,"28":1,"29":1,"30":1,"31":1,"32":1,"35":1,"36":1,"40":1,"43":1,"44":1,"45":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"59":1,"60":1,"61":1,"68":1,"70":1,"71":1,"72":1,"73":1,"74":1,"76":1,"77":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~orange-lens~paint-~0019270f","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gallery-overlay~medi~bd43bb1c","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","5":"add-to-list-drawer~bath-renovation~orange-lens","6":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"add-to-list-drawer~magic-apron","10":"buybox~promotion-products-lazy","11":"buybox~super-sku","12":"compare~overlay","13":"promotion-products-lazy~quick-view","14":"ratings-and-reviews-mobile","15":"StoreLayout","16":"add-to-list-drawer","17":"aisle-bay","18":"augmented-reality","19":"bath-renovation","20":"breadcrumbs","21":"browse-and-search","22":"browse-and-search-mobile","23":"buybox","24":"calculator-pipcalculator","25":"collections","26":"collections-mobile","27":"common","28":"compare","29":"consumer-card-messaging","30":"customer-image-overlay","31":"drawer","32":"emt-generated-content","33":"emt-links","34":"emt-questions-and-answers-component","35":"fbr","36":"global-custom-configurator","37":"hammerjs","39":"home","40":"magic-apron","41":"measurement-guide","42":"measurement-guide-overlay-content","43":"media-gallery-filmstrip-mobile","44":"media-gallery-overlay","45":"media-gallery-overlay-mobile","46":"orange-lens","47":"order-sample","48":"order-sample-drawer","49":"overlay","50":"paint-reorder","51":"paint-reorder-mobile","52":"pep","53":"pep-mobile","54":"product","55":"product-mobile","56":"product-overview","57":"promotion-products-lazy","58":"question","59":"questions-and-answers","60":"quick-view","61":"ratings-and-reviews","62":"ratings-and-reviews-desktop","63":"results","64":"returns-messaging","66":"share-to-email-overlay","67":"share-to-pinterest-overlay","68":"size-guide-overlay","69":"specifications","70":"stylequiz","71":"super-sku","72":"vendor-collection-products","73":"vendor-collections","74":"vendor-collections-mobile","76":"video-player","77":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"2134e3f2525f4b18b82f","2":"31d6cfe0d16ae931b73c","3":"dc0bc626ca15ffc94f61","4":"89d9163eeb30e835d559","5":"31d6cfe0d16ae931b73c","6":"0ef658ad0521bc70e648","7":"50d430c72ccc3cf96a34","8":"65f1d7aedc445dc5836f","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"20f2aced33e6b1ed7b41","12":"9f6e95f53122c35ea62a","13":"c076939ce172db5a3cb1","14":"2ade42f7647d0b013747","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"d94b956aa532c1a50c65","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"42652601ff0ae779858b","22":"766c85efdd2e5fc7d70f","23":"2bb695512c61ba30c420","24":"31d6cfe0d16ae931b73c","25":"6989b885c3a130631311","26":"245583dfb4167de3132b","27":"31d6cfe0d16ae931b73c","28":"e1f63ff090d5f96e31b4","29":"b71f8ffaebe49e5b8650","30":"32b2ceba1e4cfc936c08","31":"fc73174b407ad863c497","32":"b49004ddac99adec2224","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"88e24c7aafcf93ae6cc6","36":"1a5562a08d12f7682989","37":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"4be99b2862037eff2a09","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"a3d0306b84dd9d80e2af","44":"3a42c68bf5a478e99c01","45":"47afbd20419a0f96b611","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"3eae282145055105039e","50":"fc650b263badee2304d6","51":"cff893f31bdad17e93fc","52":"745a3c4f0d536aa13161","53":"5163fb2f93ed403c3fdf","54":"ea8c5649980bda7755da","55":"2161c8acb169092cf314","56":"be155bb5d11dacdc4bb8","57":"ee58265e369789fb3e9c","58":"31d6cfe0d16ae931b73c","59":"d70c859b20e57c1599c5","60":"f342e1d8e8a7fdd462d9","61":"9d02d79dc9b8f52f7762","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"453dfc2640779a848cc6","69":"31d6cfe0d16ae931b73c","70":"80dd5e6aa68c9fbca3f8","71":"b31101625f385d3bcc30","72":"e518e335254638969e62","73":"96acad5d779f9ce0b6c5","74":"760fc5b79894c2224a24","76":"24ab350a8a93783bfec6","77":"60f7c79bb330e8e8c008","78":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
